<template>
    <form>
        <dynamic-input
            class="form-group mb-4"
            :key="index"
            :input="input"
            v-for="(input, index) in schema.inputs"
        ></dynamic-input>

        <button type="submit" class="btn btn-primary">Submit</button>
    </form>
</template>

<script>
import DynamicInput from './DynamicInput';

export default {
    components: {
        DynamicInput,
    },

    props: {
        schema: {
            type: Object,
            required: true,
        },
    },
}
</script>
